import { render, staticRenderFns } from "./MplsVpnWizard.vue?vue&type=template&id=633c142c&"
import script from "./MplsVpnWizard.vue?vue&type=script&lang=js&"
export * from "./MplsVpnWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports